// Captures first-touch + current attribution for lead forms. One place, reused by every form.
const KEY = "ragi_first_touch";

export function captureFirstTouch() {
  try {
    if (localStorage.getItem(KEY)) return;
    const p = new URLSearchParams(window.location.search);
    localStorage.setItem(KEY, JSON.stringify({
      landing_page: window.location.href,
      referrer: document.referrer || null,
      utm_source: p.get("utm_source"), utm_medium: p.get("utm_medium"), utm_campaign: p.get("utm_campaign"),
      utm_content: p.get("utm_content"), utm_term: p.get("utm_term"), at: new Date().toISOString(),
    }));
  } catch { /* storage unavailable */ }
}

export function attribution() {
  let first = {};
  try { first = JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { /* ignore */ }
  const p = new URLSearchParams(window.location.search);
  return {
    page_url: window.location.href,
    landing_page: first.landing_page || window.location.href,
    referrer: document.referrer || first.referrer || null,
    utm_source: p.get("utm_source") || first.utm_source || null,
    utm_medium: p.get("utm_medium") || first.utm_medium || null,
    utm_campaign: p.get("utm_campaign") || first.utm_campaign || null,
    utm_content: p.get("utm_content") || first.utm_content || null,
    utm_term: p.get("utm_term") || first.utm_term || null,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
}
